import { connect } from 'react-redux'
import { getTags } from '@selectors/data/tag_selectors.js'
import TimelineTags from '@components/timelines/timeline_tags.jsx'

const mapStateToProps = (state, props) => {
  const { canTag, createTagsPath, timelineId } = props
  const tags = getTags(state, props)
  return {
    tags,
    canTag,
    createTagsPath,
    timelineId,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TimelineTags)
